import { config } from '@/lib/env-helpers';
import { Provider } from '@chargebee/chargebee-js-react-wrapper';
import { loadScript } from '@shared/utils/load-script';
import { useEffect, useState } from 'react';

declare global {
  interface Window {
    Chargebee: {
      init: (options: { site: string; publishableKey: string }) => void;
      getInstance: () => unknown;
    };
  }
}
const url = 'https://js.chargebee.com/v2/chargebee.js';

export default function ChargebeeProvider({ children }: { children: JSX.Element }) {
  const [cbInstance, setCbInstance] = useState<unknown>(null);

  useEffect(() => {
    loadScript(
      url,
      {
        defer: true,
      },
      (error) => {
        if (error) {
          setCbInstance(null);
        } else {
          window?.Chargebee?.init?.({
            site: config.PAYMENT_SITE,
            publishableKey: config.PAYMENT_PUBLISHABLE_KEY,
          });

          const cbInstance = window?.Chargebee?.getInstance?.();
          setCbInstance(cbInstance);
        }
      }
    );
  }, []);

  if (cbInstance) {
    return <Provider cbInstance={cbInstance}>{children}</Provider>;
  } else {
    return children;
  }
}
